const NAMESPACE = 'LateStartRoute';

Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck[NAMESPACE] = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'div',
              attributes: {
                id: 'toleranceInMinutesContainer'
              },
              items: [
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: Monet.I18n.getResourcesByKey('event.toleranceInMinutes'),
                      attributes: {
                        class: 'i18nResource',
                        name: NAMESPACE
                      },
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'tolerance_in_minutes',
                  },
                },
                {
                  items: [
                    {
                      tag: 'input',
                      attributes: {
                        type: 'text',
                        name: 'tolerance_in_minutes',
                        maxlength: '10',
                        alt: '',
                        value: '',
                        id: 'tolerance_in_minutes',
                        class: 'modelAttribute textField numberPicker mandatory',
                        autocomplete: 'off',
                        oninput: 'this.value = this.value.replace(/\\D/g, "")'
                      },
                    },
                  ],
                  attributes: {
                    class: 'controls',
                  },
                }
              ]
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'radio',
                    name: 'departureType',
                    id: 'plannedStart',
                    class: 'modelAttribute radioField',
                    checked: 'true',
                  },
                },
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: Monet.I18n.getResourcesByKey('event.LateStartRoute.plannedStart'),
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'plannedStart',
                  },
                },
              ],
              attributes: {
                class: 'controls',
                style: 'margin-top: 10px'
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'radio',
                    name: 'departureType',
                    id: 'baseLineStart',
                    class: 'modelAttribute radioField',
                  },
                },
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: Monet.I18n.getResourcesByKey('event.LateStartRoute.baseLineStart'),
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'baseLineStart',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            }
          ],
          attributes: {
            namespace: NAMESPACE,
            class: 'control-group',
            id: 'LateStartRouteEvent'
          },
        },
        {
          tag: 'input',
          attributes: {
            type:'hidden',
            name: 'namespace',
            value: NAMESPACE
          }
        }
      ],
    };
  },

  assignParameter(jsonParam) {
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      $('#tolerance_in_minutes').val(jsonParam.toleranceMinutes);

      const radioPlannedStart = document.querySelector('#LateStartRouteEvent #plannedStart');
      const radioBaseLineStart = document.querySelector('#LateStartRouteEvent #baseLineStart');

      if (jsonParam.isPlannedStart) {
        radioPlannedStart.checked = true;
        radioBaseLineStart.checked = false;
      } else if (jsonParam.isBaseLineStart) {
        radioBaseLineStart.checked = true;
        radioPlannedStart.checked = false;
      }
    }
  },

  retrieveParameter() {
    const timeMinutes = parseInt($('#tolerance_in_minutes').val(), 10);
    const radioPlannedStart = document.querySelector('#LateStartRouteEvent #plannedStart');
    const radioBaseLineStart = document.querySelector('#LateStartRouteEvent #baseLineStart');

    return JSON.stringify({
      toleranceMinutes: timeMinutes,
      isPlannedStart: radioPlannedStart.checked,
      isBaseLineStart: radioBaseLineStart.checked
    });
  },

  validateParameter(validation) {
    const controlGroup = App.Forms.Event.form.rootEl.querySelector(`[namespace="${NAMESPACE}"]`);
    const toleranceInMinutesInput = controlGroup && controlGroup.querySelector('#tolerance_in_minutes');
    const toleranceInMinutesContainer = controlGroup && controlGroup.querySelector('#toleranceInMinutesContainer');

    if (controlGroup && toleranceInMinutesInput && toleranceInMinutesContainer) {
      const value = parseInt(toleranceInMinutesInput.value, 10);
      const errorClass = 'error';
      const isValid = !isNaN(value);
      
      if (!isValid) {
        validation.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(
          'general.mandatoryField', Monet.I18n.getResourcesByKey('event.toleranceInMinutes')
        ));
        toleranceInMinutesContainer.classList.add(errorClass);
      } else {
        toleranceInMinutesContainer.classList.remove(errorClass);
      }
    }
  }
};
